import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Table, Form, Alert } from "react-bootstrap";
import { integer } from "aws-sdk/clients/storagegateway";
import { hasErrorCode, getErrorMessage } from "../../../../utils/errorUtils";


const ImportList = (props: any) => {
    const [CSVHeaders, setCSVHeaders] = useState<any>();
    const [Shortcodes, setShortcodes] = useState<any>([]);
    const [mappedCSVHeaders, setMappedCSVHeaders] = useState<any>();
    const [showSuccess, setShowSuccess] = useState<any>(false);
    const [showFail, setShowFail] = useState<any>(false);
        
    useEffect(() => {
        setCSVHeaders(props.CSVHeaders);
    }, [props.CSVHeaders]); 
        
    useEffect(() => {
        setMappedCSVHeaders(props.mappedCSVHeaders);
    }, [props.mappedCSVHeaders]);     
    
    useEffect(() => {
        setShortcodes(modifyShortcodes(props.Shortcodes));
    }, [props.Shortcodes]);  

    const modifyShortcodes = (shortcodes:any) => {
        let tempShortcodes: any = shortcodes;
        tempShortcodes.unshift({"id":null,"name":"Unmapped"}); // Add a value to top for unmapped components
        return tempShortcodes;
    }     
    
    // Set display to none for all other dropdowns (this way a shortcode cannot be used twice)
    const modifyShortcodeOptions = (e:any) => {
        console.log(e.target.name)
        console.log(e.target.value)
        console.log(mappedCSVHeaders)
        if (mappedCSVHeaders[parseInt((e.target.name).replace("index-", ""))][3]){
            console.log("Existing Selection", mappedCSVHeaders[parseInt((e.target.name).replace("index-", ""))][3])
            addRemoveOption(mappedCSVHeaders[parseInt((e.target.name).replace("index-", ""))][3],false)
        }
        addRemoveOption(e.target.value,true)
        mappedCSVHeaders[parseInt((e.target.name).replace("index-", ""))][3] = e.target.value;
    }   

    // Helper function to add or remove display:none to options that are already taken.
    const addRemoveOption = (val:any, turnOff:boolean) => {
        let _options = document.querySelectorAll(".option-" + val);
        for (let i:any = 0; i < _options.length; ++i) {
            if (turnOff) {              
                if (!_options[i].classList.contains("off-syncarto")){
                    _options[i].classList.add("off-syncarto")
                }
            }else{
                if (_options[i].classList.contains("off-syncarto")){
                    _options[i].classList.remove("off-syncarto")
                }
            }
        }
    }

    //console.log("ImportList > props", props)

    if (CSVHeaders == null || mappedCSVHeaders == null ) {
        return (
            <div>Load CSV to begin import... </div>
        )
    }
    
    //console.log("ImportList > CSVHeaders", CSVHeaders)
    //console.log("ImportList > Shortcodes", Shortcodes)
    //console.log("ImportList > mappedCSVHeaders", mappedCSVHeaders)
    let initialSelectionValues: any = {};
    let mappingsExist = false;
    mappedCSVHeaders.forEach((header: any, index: any) => {
        initialSelectionValues["index-" + index ] = header[3] ? header[3] : ''; 
        if(header[3]){mappingsExist = true}
    });
    //console.log("ImportList >  initialSelectionValues",  initialSelectionValues)

    const validate = (values:any) => {
        var errors: {[k: string]: any} = {};

        /* Will connect error handling depending on how the data is used by API
        if (values.title === "") {
            errors.title = 'Required';
        }*/

        return errors;
    };

    // When the form is recreated (i.e., a new CSV is uploaded), hidden <options> neet their hiding class removed 
    //  ...do this only when no mappings exist 
    if (!mappingsExist){
        let _options = document.querySelectorAll(".off-syncarto");
        for (let i:any = 0; i < _options.length; ++i) {
            if (_options[i].classList.contains("off-syncarto")){
                _options[i].classList.remove("off-syncarto")
            }
        }
    }

    console.log("ImportList >  rendering... ")
    return (
        <Formik 
            enableReinitialize={true} // Resets form's selected values if the user uploads a new CSV
            initialValues= {initialSelectionValues}
            validateOnChange={false}
            validateOnBlur={false}
            validate={validate}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
                setSubmitting(true);
                console.log("submitting...");
                try {

                    mappedCSVHeaders.forEach((field:any, index:integer) => {
                        field[3] = values["index-" + index];
                        if (values["index-" + index]){
                            field[4] = Shortcodes[(parseInt(values["index-" + index]) + 1)];
                        }else{
                            field[4] = null;
                        }
                    })
                    console.log("mappedCSVHeaders FINAL", mappedCSVHeaders)
    

                    //await createSource({...sourceData});

                    setShowSuccess(true);

                    /*setTimeout(() => {
                        const { shouldRefreshSources } = props;
                        shouldRefreshSources();
                    },500); */ 

                    setTimeout(() => {
                        setShowSuccess(false);
                    },1500);

                    //resetForm();
                } catch(e) {
                    console.error(e);
                    if (hasErrorCode(e)) {
                        alert(getErrorMessage(e));
                    }
                    setShowFail(true);
                    setTimeout(() => {
                        setShowFail(false);
                    },1500);
                }
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <>
                    <Form noValidate onSubmit={handleSubmit} autoComplete="off">  
                        <Table striped bordered hover variant="dark">
                            <thead>
                                <tr>
                                    <th>CSV Block</th>
                                    <th>Shortcode Mapping</th>
                                    <th>Example Record 1</th>
                                    <th>Example Record 2</th>
                                </tr>
                            </thead>
                            <tbody>       
                                    {
                                    CSVHeaders.map((field:any, index:integer) => (
                                        <tr key={index + "_row"}>
                                            <td>{field[0]}</td>
                                            <td key={index + "_map"}>
                                                <Form.Control
                                                    as="select"
                                                    name={"index-" + index}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        modifyShortcodeOptions(e);
                                                      }}
                                                    value={values["index-" + index]}
                                                    onBlur={handleBlur}
                                                    //isInvalid={!!errors.data_source_type_id}
                                                >
                                                    {
                                                        props.Shortcodes.map((optionElement: any) => {
                                                            return (
                                                                <option className={ "option-" + optionElement.id} key={optionElement.id} value={optionElement.id}>{optionElement.name}</option>
                                                            );
                                                        })
                                                    }
                                                </Form.Control>  
                                            </td>
                                            <td>{field[1]}</td>
                                            <td>{field[2]}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={isSubmitting}
                        >
                            Import
                        </Button>                    
                        <Alert show={showSuccess} variant="success" className="query-success-syncarto">
                            Import complete!
                        </Alert>                    
                        <Alert show={showFail} variant="warning" className="query-success-syncarto">
                            There was an issue with importing!
                        </Alert>
                    </Form>
                </>
            )}
        </Formik>   
    );
}

export default ImportList;